// extracted by mini-css-extract-plugin
export const container = "l_p";
export const root = "l_c";
export const footer = "l_q";
export const links = "l_r";
export const desktop = "l_s";
export const mobile = "l_t";
export const logo = "l_v";